import React from 'react';
import { Box } from '@chakra-ui/react';

function Card({ children = null, ...rest }) {
  return (
    <Box
      bg="white"
      display={{ md: 'flex' }}
      minWidth={{ base: null, md: '60%', lg: '50%' }}
      mb={10}
      borderRadius=".35rem"
      dir="row"
      justifyContent="left"
      borderWidth={2}
      borderColor="gray.300"
      {...rest}
    >
      {children}
    </Box>
  );
}

export default Card;
